import React from 'react';
import { connect } from 'react-redux';

import ProfileSidebar from '../../../Components/Profile/ProfileSidebar';

const LeftSection = ({ profile }) => (
  <ProfileSidebar
    profile={profile}
    editPath="/profile"
    showRating
    details={[
      { label: 'Type de compte', value: profile.user_type || 'Client' },
      { label: 'Téléphone', value: profile.phone_number },
      { label: 'Adresse', value: profile.address },
    ]}
  />
);

const mapStateToProps = ({ firebase }) => ({ profile: firebase.profile || {} });
export default connect(mapStateToProps)(LeftSection);
